import script from './component-lib.esm4.js';
export { InputProps } from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', _vm._g({
    staticClass: "v-input",
    class: _vm.inputClasses,
    style: _vm.styles,
    attrs: {
      "id": _vm.rootId,
      "for": _vm.inputId
    }
  }, _vm.listeners), [_vm._t("before"), _vm._v(" "), _vm.$slots.prepend ? _c('div', {
    staticClass: "v-input__prepend",
    class: _vm.classes.prepend
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "v-input__control-wrapper",
    class: _vm.classes.wrapper
  }, [_vm.prefix ? _c('div', {
    staticClass: "v-input__prefix"
  }, [_vm._v("\n      " + _vm._s(_vm.prefix) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.inputAttrs.type === 'checkbox' && _vm.component === 'input' ? _c('input', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.localValue,
      expression: "localValue"
    }],
    ref: "input",
    staticClass: "v-input__field",
    attrs: {
      "id": _vm.inputId,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localValue) ? _vm._i(_vm.localValue, null) > -1 : _vm.localValue
    },
    on: {
      "keyup": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "keydown": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": function ($event) {
        var $$a = _vm.localValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.localValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.localValue = $$c;
        }
      }
    }
  }, 'input', _vm.inputAttrs, false), _vm.inputListeners)) : _vm.inputAttrs.type === 'radio' && _vm.component === 'input' ? _c('input', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.localValue,
      expression: "localValue"
    }],
    ref: "input",
    staticClass: "v-input__field",
    attrs: {
      "id": _vm.inputId,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.localValue, null)
    },
    on: {
      "keyup": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "keydown": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": function ($event) {
        _vm.localValue = null;
      }
    }
  }, 'input', _vm.inputAttrs, false), _vm.inputListeners)) : _vm.component === 'input' ? _c('input', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.localValue,
      expression: "localValue"
    }],
    ref: "input",
    staticClass: "v-input__field",
    attrs: {
      "id": _vm.inputId,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "type": _vm.inputAttrs.type
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "keyup": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "keydown": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.localValue = $event.target.value;
      }
    }
  }, 'input', _vm.inputAttrs, false), _vm.inputListeners)) : _vm.component === 'select' ? _c('select', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.localValue,
      expression: "localValue"
    }],
    ref: "input",
    staticClass: "v-input__field",
    attrs: {
      "id": _vm.inputId,
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    on: {
      "keyup": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "keydown": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.localValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, 'select', _vm.inputAttrs, false), _vm.inputListeners), [_vm._t("default")], 2) : _vm.component === 'textarea' ? _c('textarea', _vm._g(_vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.localValue,
      expression: "localValue"
    }],
    ref: "input",
    staticClass: "v-input__field",
    attrs: {
      "id": _vm.inputId,
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.localValue
    },
    on: {
      "keyup": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "keydown": function ($event) {
        return _vm.$emit('keyup', $event);
      },
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.localValue = $event.target.value;
      }
    }
  }, 'textarea', _vm.inputAttrs, false), _vm.inputListeners)) : _vm._e(), _vm._v(" "), _vm.suffix ? _c('div', {
    staticClass: "v-input__suffix"
  }, [_vm._v("\n      " + _vm._s(_vm.suffix) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm.$slots.append ? _c('div', {
    staticClass: "v-input__append",
    class: _vm.classes.append
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), _vm._t("after")], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-74a22bf0_0", {
    source: ".v-input[data-v-74a22bf0]{--c-side-padding:0.925rem;align-items:unset;background-color:#fff;border:solid 1px var(--ci-color-border);border-radius:var(--g-border-radius-standard);display:flex;color:var(--g-color-on-bg);cursor:pointer;font:400 1rem var(--g-font-input-family);line-height:normal;height:2.625rem;padding:0 var(--c-side-padding);text-align:left;transition:all var(--g-transition-speed);width:100%}.v-input[data-v-74a22bf0]::-webkit-input-placeholder{color:var(--g-color-gray-400)}.v-input[data-v-74a22bf0]::-moz-placeholder{color:var(--g-color-gray-400)}.v-input[data-v-74a22bf0]:-ms-input-placeholder{color:var(--g-color-gray-400)}.v-input--focus[data-v-74a22bf0]:not(.v-input--readonly),.v-input[data-v-74a22bf0]:hover:not(.v-input--readonly):not(.v-input--disabled){background:var(--ci-color-bg-focus);border-color:var(--ci-color-border-focus)}.v-input--disabled[data-v-74a22bf0]{background:var(--g-color-gray-100);cursor:not-allowed}.v-input--disabled .v-input__append[data-v-74a22bf0],.v-input--disabled .v-input__prepend[data-v-74a22bf0]{opacity:.75}.v-input--disabled .v-input__field[data-v-74a22bf0]{cursor:inherit}.v-input--error[data-v-74a22bf0]{background:var(--ci-color-bg-error);border-color:var(--g-color-error)}.v-input--multiline[data-v-74a22bf0]{height:unset;border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min))}.v-input__field[data-v-74a22bf0]{appearance:none;background:0 0;border:none;border-radius:0;font:inherit;font-family:var(--g-font-input-family);flex-grow:1;min-width:0;outline:0;padding:.5rem 0;max-height:unset}.v-input__field[type=password][data-v-74a22bf0]::-ms-reveal{display:none}.v-input__append[data-v-74a22bf0],.v-input__prefix[data-v-74a22bf0],.v-input__prepend[data-v-74a22bf0],.v-input__suffix[data-v-74a22bf0]{align-items:center;display:inline-flex}.v-input__append .v-icon-btn[data-v-74a22bf0],.v-input__prefix .v-icon-btn[data-v-74a22bf0],.v-input__prepend .v-icon-btn[data-v-74a22bf0],.v-input__suffix .v-icon-btn[data-v-74a22bf0]{font-size:1.15rem}.v-input__append .v-svg-icon[data-v-74a22bf0],.v-input__prepend .v-svg-icon[data-v-74a22bf0]{font-size:1.25rem}.v-input__prepend[data-v-74a22bf0]{padding-right:var(--c-side-padding)}.v-input__prepend .v-icon-btn[data-v-74a22bf0]{margin-left:-.4em;margin-right:-.4em}.v-input__append[data-v-74a22bf0]{padding-left:var(--c-side-padding)}.v-input__append .v-icon-btn[data-v-74a22bf0]{margin-left:-.4em;margin-right:-.4em}.v-input__control-wrapper[data-v-74a22bf0]{display:flex;flex-grow:1;min-width:0}.v-input__prefix[data-v-74a22bf0],.v-input__suffix[data-v-74a22bf0]{pointer-events:none}.v-input__prefix[data-v-74a22bf0]{padding-right:.25rem}.v-input__suffix[data-v-74a22bf0]{padding-left:.25rem}textarea.v-input__field[data-v-74a22bf0]{height:auto;resize:vertical;max-width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-74a22bf0";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Input = __vue_component__;
export { Input as default };